module.exports = __webpack_public_path__ + "img/TNP_Teilnahmebedingungen_TNP-Wochen.311db261.png";